// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"tabs_tabContainer__35sBQ","tab":"tabs_tab__2gLlA","selectedTab":"tabs_selectedTab__2BToc"};